import React from "react";
import { getVarsoUrl, DEFAULT_COLOR } from "../../../../common/helpers/helpers";
import {
  getPathogenicityColorByAllNames,
  ACMG_PATHOGENICITY_COLORS,
} from "../../../../common/helpers/Constant";
import { DATABASE_NAMES, DATABASE_URLS } from "./constants";
import HelperText from "../../../../components/atoms/HelperText";
import {
  pathogenicVeryStrongColor,
  pathogenicModerateColor,
  benignVeryStrongColor,
  uncertainColor,
  benignModerateColor,
  drugResponseColor,
  riskFactorColor,
} from "../../../../common/helpers/colors";
import { verdictExplanation } from "./verdictExplanation";
import { HorizontalStackedBar } from "../../../../components/atoms";

export function verdictPointsCalculation(accessionArray) {
  let benignPoints = 0;
  let likelyBenignPoints = 0;
  let uncertainPoints = 0;
  let pathogenicPoints = 0;
  let likelyPathogenicPoints = 0;
  let drugResponsePoints = 0;
  let riskFactorPoints = 0;
  accessionArray
    .map((accession) => accession)
    .map((acc) => acc.submissions)
    .map((dataItem) =>
      dataItem
        .map((innerDataItem) => innerDataItem.clinical_significance)
        .reduce((a, i) => a + i, "")
    )
    .map((clinSign) => {
      if (clinSign.includes("Pathogenic")) {
        pathogenicPoints += clinSign.split("Pathogenic").length - 1;
      }
      if (clinSign.includes("Uncertain significance")) {
        uncertainPoints += clinSign.split("Uncertain significance").length - 1;
      }
      if (clinSign.includes("Likely pathogenic")) {
        likelyPathogenicPoints +=
          clinSign.split("Likely pathogenic").length - 1;
      }
      if (clinSign.includes("Benign")) {
        benignPoints += clinSign.split("Benign").length - 1;
      }
      if (clinSign.includes("Likely benign")) {
        likelyBenignPoints += clinSign.split("Likely benign").length - 1;
      }
      if (clinSign.includes("drug response")) {
        drugResponsePoints += clinSign.split("drug response").length - 1;
      }
      if (clinSign.includes("risk factor")) {
        riskFactorPoints += clinSign.split("risk factor").length - 1;
      }
      return null;
    });
  const finalVerdicts = [
    {
      value: pathogenicPoints,
      color: pathogenicVeryStrongColor,
      label: "Pathogenic",
      text: `${pathogenicPoints}`,
    },
    {
      value: likelyPathogenicPoints,
      color: pathogenicModerateColor,
      label: "Likely Pathogenic",
      text: `${likelyPathogenicPoints}`,
    },
    {
      value: uncertainPoints,
      color: uncertainColor,
      label: "Uncertain Significance",
      text: `${uncertainPoints}`,
    },
    {
      value: likelyBenignPoints,
      color: benignModerateColor,
      label: "Likely Benign",
      text: `${likelyBenignPoints}`,
    },
    {
      value: benignPoints,
      color: benignVeryStrongColor,
      label: "Benign",
      text: `${benignPoints}`,
    },
    {
      value: drugResponsePoints,
      color: drugResponseColor,
      label: "Drug Response",
      text: `${drugResponsePoints}`,
    },
    {
      value: riskFactorPoints,
      color: riskFactorColor,
      label: "Risk Factor",
      text: `${riskFactorPoints}`,
    },
  ];

  return finalVerdicts;
}
export function uniqueVerdict(mergedBarchartData, pathogenicityLabels) {
  const finalVerdicts = pathogenicityLabels.map((pathogenicityLabel) => {
    const pathogenicity = mergedBarchartData.filter(
      (i) => i.label === pathogenicityLabel
    );
    const verdict = pathogenicity[0];
    if (verdict) {
      return {
        ...verdict,
        value: pathogenicity.map((i) => i.value).reduce((a, c) => a + c, 0),
        text: verdict.value.toString(),
      };
    }
    return null;
  });

  return finalVerdicts;
}

export function showClinvarCardBarchart(clinvarData) {
  const barchartData = (clinvarData || [])
    .map((clinvarItem) => clinvarItem?.accessions || [])
    .map((i) => verdictPointsCalculation(i));

  const mergedBarchartData = [].concat(...barchartData);

  const pathogenicities = [
    "Pathogenic",
    "Likely Pathogenic",
    "Uncertain Significance",
    "Likely Benign",
    "Benign",
    "Drug Response",
    "Risk Factor",
  ];

  const finalVerdicts = uniqueVerdict(mergedBarchartData, pathogenicities);

  return (
    <div className="tw-flex tw-mx-auto tw-pb-0">
      <div
        className="tw-container tw-flex-grow tw-text-white tw-ml-0"
        style={{ maxWidth: "280px" }}
      >
        <HorizontalStackedBar
          className="tw-h-5 tw-text-xs"
          data={finalVerdicts}
        />
      </div>
    </div>
  );
}

export function showVerdictLine(accessionArray) {
  const points = verdictPointsCalculation(accessionArray);
  const valuesArray = points.map((i) => i.value);
  const [
    pathogenicPoints,
    likelyPathogenicPoints,
    uncertainPoints,
    likelyBenignPoints,
    benignPoints,
  ] = valuesArray;
  return (
    <div>
      {pathogenicPoints ? (
        <span>
          P:
          <span style={{ color: pathogenicVeryStrongColor }}>
            {pathogenicPoints}
          </span>
        </span>
      ) : (
        ""
      )}{" "}
      {likelyPathogenicPoints ? (
        <span>
          LP:
          <span style={{ color: pathogenicModerateColor }}>
            {likelyPathogenicPoints}
          </span>
        </span>
      ) : (
        ""
      )}{" "}
      {uncertainPoints ? (
        <span>
          VUS:
          <span style={{ color: uncertainColor }}>{uncertainPoints}</span>
        </span>
      ) : (
        ""
      )}{" "}
      {likelyBenignPoints ? (
        <span>
          LB:
          <span style={{ color: benignModerateColor }}>
            {likelyBenignPoints}
          </span>
        </span>
      ) : (
        ""
      )}{" "}
      {benignPoints ? (
        <span>
          B:
          <span style={{ color: benignVeryStrongColor }}>{benignPoints} </span>
        </span>
      ) : (
        ""
      )}{" "}
      {valuesArray.slice(0, 5).some((element) => element !== 0) ? (
        <HelperText
          RenderContent={() => verdictExplanation}
          title="Verdict Explanation"
        />
      ) : (
        ""
      )}
    </div>
  );
}
export function colorsForListElements(significanceArray) {
  return (
    <div>
      {significanceArray?.map((arrayValue, i) => (
        <div
          key={`${i}-${new Date().getTime()}`}
          style={{ color: getPathogenicityColorByAllNames(arrayValue) }}
        >
          {arrayValue}
        </div>
      ))}
    </div>
  );
}
export function countSubmissionsInAccessionArray(acc) {
  return acc
    .map((accItem) => accItem?.submissions || [])
    .map((submissions) => submissions.length)
    .reduce((a, i) => a + i, 0);
}
export function getPathogenicityStyle(submission) {
  const key = submission?.review_description || "";
  const lowerCaseKey = key.toLowerCase();
  const color = ACMG_PATHOGENICITY_COLORS[lowerCaseKey] || DEFAULT_COLOR;
  return { color };
}

export const getDatabaseLink = (item, id) => {
  if (item && DATABASE_URLS[item]) {
    return (
      <a
        href={getVarsoUrl(DATABASE_URLS[item].replace("INSERT_ID", id))}
        target="_blank"
      >
        {DATABASE_NAMES[item]}
      </a>
    );
  }
  const dbName = DATABASE_NAMES.hasOwnProperty(item)
    ? DATABASE_NAMES[item]
    : item;
  return <span>{`${dbName}: ${id}`}</span>;
};
export const renderReviewStars = (item) => {
  const stars = [];
  for (let i = 0; i < item.review_stars; i++) {
    stars.push(
      <i
        className="varsome-icons icon-star"
        style={{ color: "grey" }}
        key={i}
      />
    );
  }
  for (let i = item.review_stars; i < 4; i++) {
    stars.push(
      <i
        className="varsome-icons icon-star-o"
        style={{ color: "grey" }}
        key={i}
      />
    );
  }
  return stars;
};
export const colorClinicalSignificance = (clinicalSignificance) => {
  return (
    <div>
      {clinicalSignificance.map((significance, i) => {
        const color = getPathogenicityColorByAllNames(
          significance.toLowerCase()
        );
        const fontWeight = color ? "bold" : "";
        return (
          <div
            style={{ color, fontWeight }}
            className="varsome-horiz-list-value"
            key={i}
          >
            {significance}
          </div>
        );
      })}
    </div>
  );
};
export const sumFields = (acc, field) => {
  if (!acc.submissions) return;
  const counterMap = {};
  for (let i = 0; i < acc.submissions.length; i++) {
    const subm = acc.submissions[i];
    const val = subm[field];
    // eslint-disable-next-line no-continue
    if (!val) continue;
    if (counterMap.hasOwnProperty(val)) {
      counterMap[val] += 1;
    } else {
      counterMap[val] = 1;
    }
  }
  const result = (
    <div>
      {Object.keys(counterMap).map((val, i) => {
        return (
          <span key={i}>
            {val}
            {Object.keys(counterMap).length > 1 && `(${counterMap[val]})`}
            {i < Object.keys(counterMap).length - 1 && ", "}
          </span>
        );
      })}
    </div>
  );
  // eslint-disable-next-line consistent-return
  return result;
};
export const getMainName = (names) => {
  if (names) {
    return <b> {names[0]}</b>;
  }
  return null;
};
export const getOtherNames = (names) => {
  if (names) {
    const otherNames = [...names];
    otherNames.splice(0, 1);
    if (Array.isArray(otherNames) && otherNames.length) return otherNames;
  }
  return null;
};
